import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export default function Register() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try { await register(name, email, password); nav("/account"); }
    catch {} finally { setBusy(false); }
  };

  return (
    <div className="ja-container py-24 max-w-md" data-testid="register-page">
      <div className="text-center mb-12">
        <p className="ja-overline">Begin Your Journey</p>
        <h1 className="ja-serif text-5xl mt-3 tracking-tight">Create Account</h1>
      </div>
      <form onSubmit={submit} className="space-y-8">
        <input required placeholder="Full Name" className="ja-input" value={name} onChange={(e) => setName(e.target.value)} data-testid="register-name" />
        <input type="email" required placeholder="Email Address" className="ja-input" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="register-email" />
        <input type="password" required minLength={6} placeholder="Password (min 6)" className="ja-input" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="register-password" />
        <button type="submit" disabled={busy} className="ja-btn w-full" data-testid="register-submit">{busy ? "Creating…" : "Create Account"}</button>
      </form>
      <p className="text-center text-sm mt-10" style={{ color: "var(--ja-muted)" }}>
        Already a member? <Link to="/login" className="underline" data-testid="link-login">Sign in</Link>
      </p>
    </div>
  );
}
